import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasChanges", "parentSet", "skills", "onChangeSkills"];
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import filterObject from 'utils/filterObject';
import createLocation from 'utils/createLocation';
import toArray from 'utils/toArray';
import { SKILL_ROUTES } from 'utils/routes';
import FormField from 'components/FormField';
import Button from 'components/Button';
import ShadedListItem from 'components/ShadedListItem';
import Stack from 'components/Stack';
import UnsavedChangesModal from 'screens/UnsavedChangesModal';
import SkillPickerModal from 'screens/SkillPickerModal';
function SkillsField(_ref) {
  var hasChanges = _ref.hasChanges,
    parentSet = _ref.parentSet,
    skills = _ref.skills,
    onChangeSkills = _ref.onChangeSkills,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var history = useHistory();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pendingSkillId = _useState2[0],
    setPendingSkillId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasSkillPickerModal = _useState4[0],
    setHasSkillPickerModal = _useState4[1];
  function navigateToSkill(skillId) {
    history.push(createLocation(SKILL_ROUTES.root, filterObject({
      tab: 'skills',
      skillsSelection: [skillId],
      parentSetId: parentSet === null || parentSet === void 0 ? void 0 : parentSet.id,
      parentSetName: parentSet === null || parentSet === void 0 ? void 0 : parentSet.name
    })));
  }
  function onEditSkill(skillId) {
    if (hasChanges) {
      setPendingSkillId(skillId);
    } else {
      navigateToSkill(skillId);
    }
  }
  function onDiscardChanges() {
    if (pendingSkillId) {
      navigateToSkill(pendingSkillId);
      setPendingSkillId(null);
    }
  }
  function onRemoveSkill(skillId) {
    var skillsToRemove = skills.filter(function (item) {
      return item.id === skillId;
    });
    if (skillsToRemove) {
      onChangeSkills({
        toRemove: skillsToRemove
      });
    }
  }
  function onSubmitSkills(_ref2) {
    var toAdd = _ref2.toAdd,
      toRemove = _ref2.toRemove;
    onChangeSkills({
      toAdd: toArray(toAdd),
      toRemove: toArray(toRemove)
    });
    setHasSkillPickerModal(false);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormField, _extends({
    as: "fieldset",
    required: true,
    label: "".concat(t('content_type_skill_plural'), " *"),
    alert: skills.length === 0 ? t('form_alert_required_field') : undefined
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, _toConsumableArray(skills).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }).map(function (item) {
    return /*#__PURE__*/React.createElement(ShadedListItem, {
      key: item.id,
      id: item.id,
      title: item.name,
      onEdit: onEditSkill,
      onRemove: onRemoveSkill
    });
  }), /*#__PURE__*/React.createElement(Button, {
    icon: "edit",
    onClick: function onClick() {
      return setHasSkillPickerModal(true);
    },
    size: "medium"
  }, t('actions_select_skills')))), pendingSkillId && /*#__PURE__*/React.createElement(UnsavedChangesModal, {
    canSaveChanges: false,
    onDiscardChanges: onDiscardChanges,
    onClose: function onClose() {
      return setPendingSkillId(null);
    }
  }), hasSkillPickerModal && /*#__PURE__*/React.createElement(SkillPickerModal, {
    onClose: function onClose() {
      return setHasSkillPickerModal(false);
    },
    onSubmit: onSubmitSkills,
    defaultSelectedItems: skills
  }));
}
export default SkillsField;